var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95399 6.9783L13.4245 2.55122L14.3359 1.63976C14.4661 1.50955 14.4661 1.29253 14.3359 1.11892L13.3811 0.164063C13.2075 0.0338542 12.9905 0.0338542 12.8602 0.164063L7.5217 5.54601L2.13976 0.164063C2.00955 0.0338542 1.79253 0.0338542 1.61892 0.164063L0.664063 1.11892C0.533854 1.29253 0.533854 1.50955 0.664063 1.63976L6.04601 6.9783L0.664063 12.3602C0.533854 12.4905 0.533854 12.7075 0.664063 12.8811L1.61892 13.8359C1.79253 13.9661 2.00955 13.9661 2.13976 13.8359L7.5217 8.45399L11.9488 12.9245L12.8602 13.8359C12.9905 13.9661 13.2075 13.9661 13.3811 13.8359L14.3359 12.8811C14.4661 12.7075 14.4661 12.4905 14.3359 12.3602L8.95399 6.9783Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3e024281c8f210d1af11c6eaeb34abf5.svg";
export { ForwardRef as ReactComponent };